import wrapperHOC from "@Utils/wrapperHOC";
import useTranslationHook from "hooks/useTranslationHook";
import ArrowUpRed from "@Icons/ArrowUpRed";
import ArrowDownGreen from "@Icons/ArrowDownGreen";
import InfoIcon from "@Icons/InfoIcon";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import { CostOfLivingData } from "../types";
import { resolveCopy, renderBoldText } from "../utils";
import HeroCard from "./HeroCard";
import styles from "../neighbourhoodSection.module.scss";

type CostOfLivingTabProps = {
  data: CostOfLivingData;
};

const CostOfLivingTab = ({ data }: CostOfLivingTabProps) => {
  const { t } = useTranslationHook();

  const heroLabel = data.direction
    ? resolveCopy(t, data.comparisonLabelKey, data.comparisonLabelParams)
    : undefined;
  const heroSuffix = data.direction
    ? resolveCopy(
        t,
        `propertypage.components.neighbourhood.costOfLiving.hero.suffix.${data.direction}`,
      )
    : undefined;
  const source = resolveCopy(t, data.sourceKey);

  return (
    <div className={styles.contentArea}>
      <HeroCard
        image={data.heroImage}
        stat={data.percentageDiff}
        statSuffix={heroSuffix}
        label={heroLabel}
        alt="Cost of living neighbourhood view"
      />
      <div className={styles.detailsSection}>
        <div>
          {(() => {
            let renderedCount = 0;
            return data.facts.map((fact, index) => {
              const statement = resolveCopy(t, fact.key, fact.params);
              if (!statement) return null;
              const isFirst = renderedCount === 0;
              renderedCount += 1;

              return (
                <div key={fact.key}>
                  <div
                    className={formatClassNames(styles.tableRow, isFirst && styles.tableRowFirst)}
                  >
                    <span className={styles.tableText}>{renderBoldText(statement)}</span>
                    <span className={styles.tableIcon} aria-hidden="true">
                      {fact.trend === "up" && <ArrowUpRed />}
                      {fact.trend === "down" && <ArrowDownGreen />}
                    </span>
                  </div>
                  {index < data.facts.length - 1 && <div className={styles.tableDivider} />}
                </div>
              );
            });
          })()}
        </div>
        <p className={styles.sourceText}>
          <span className={styles.sourceIcon} aria-hidden="true">
            <InfoIcon width="14" height="14" fill="#6b7280" />
          </span>
          {source}
        </p>
      </div>
    </div>
  );
};

export default wrapperHOC(CostOfLivingTab, {
  componentName: "CostOfLivingTab",
  showForChina: false,
  showForWhiteLable: false,
});
